module.exports = __webpack_public_path__ + "assets/hamburger_mobile-7c72a7.svg";